export default __webpack_public_path__ + "media/zurb/img/lab/thumbnails/patterntap/typp-6ce92d62614e226507eb32cf09851e53.png";